export default "__VITE_PUBLIC_ASSET__91e7023f__"